/**
 * Workflow Constants
 * Stage transition rules from backend campaignWorkflowService.js
 */

// Valid manual stage transitions (mirrors backend STAGE_TRANSITIONS)
export const STAGE_TRANSITIONS = {
 waiting_to_start: ['recruitment', 'live', 'finished'],
 recruitment: ['waiting_to_start', 'live', 'finished'],
 live: ['waiting_to_start', 'recruitment', 'payment_report', 'finished'],
 payment_report: ['waiting_to_start', 'live', 'finished'],
 finished: ['waiting_to_start']
};

/**
 * Check if a stage transition is valid
 * @param {string} fromStage - Current stage
 * @param {string} toStage - Target stage
 * @returns {boolean} True if transition is allowed
 */
export const isValidTransition = (fromStage, toStage) => {
 if (fromStage === toStage) return false; // Can't move to same stage
 const allowedTransitions = STAGE_TRANSITIONS[fromStage];
 return allowedTransitions && allowedTransitions.includes(toStage);
};

// Drag-and-drop item type
export const DND_TYPES = {
 CAMPAIGN_CARD: 'CAMPAIGN_CARD'
};
